export default __webpack_public_path__ + "static/media/stoly1.139192df.jpg";